import Swiper from 'swiper/bundle';

const FADE_SPEED = 800;

const homeHeroSwiper = () => {
  const swiperElement = document.querySelector('#js-home-hero-swiper');

  if (!swiperElement) return;

  const progressBar = document.querySelector('#js-home-hero-swiper-bar');
  const currentNumElement = document.querySelector('#js-home-hero-swiper-current');
  const maxNumElement = document.querySelector('#js-home-hero-swiper-max');

  const AUTO_PLAY_TIME = 5000;

  const ACTIVE = 'is-active';

  const root = document.querySelector(':root');
  root.style.setProperty("--home-hero-swiper-img-transition", `${(AUTO_PLAY_TIME) * 0.001}s`);
  root.style.setProperty("--home-hero-swiper-transition", `${(AUTO_PLAY_TIME) * 0.001}s`);
  root.style.setProperty("--home-hero-swiper-speed", `${(FADE_SPEED) * 0.001}s`);


  let swiper = new Swiper(swiperElement, {
    init: false,
    effect: 'fade',
    loop: true,
    speed: FADE_SPEED,
    fadeEffect: {
      // crossFade: true
    },
    autoplay: {
      disableOnInteraction: false,
      delay: AUTO_PLAY_TIME,
    },
    navigation: {
      nextEl: '#js-home-hero-swiper-next-button',
      prevEl: '#js-home-hero-swiper-prev-button',
    },
    on: {
      init: () => {
        currentNumElement.textContent = String(swiper.activeIndex + 1).padStart(2, '0');
        maxNumElement.textContent = String(swiper.slides.length).padStart(2, '0');
      },
      afterInit: () => {
        progressBar.classList.add(ACTIVE);
      },
      slideChange: () => {
        currentNumElement.textContent = String(swiper.realIndex + 1).padStart(2, '0');
        progressBar.classList.remove(ACTIVE);
      },
      slideChangeTransitionEnd: () => {
        progressBar.classList.add(ACTIVE);
      }
    }
  });



  return {
    init: () => {
      swiper.init();
    }
  };
};

const carouselSwiper = () => {
  const swiperElements = document.querySelectorAll('.js-carousel-swiper');

  if (swiperElements.length === 0) return;

  swiperElements.forEach(swiperElement => {
    const swiperWrapper = swiperElement.querySelector('.swiper-wrapper');
    const innerElements = swiperWrapper.innerHTML;

    swiperWrapper.innerHTML += innerElements + innerElements;

    let swiper = new Swiper(swiperElement, {
      init: false,
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 20,
      speed: 6000,
      allowTouchMove: false,
      autoplay: {
        disableOnInteraction: false,
        delay: 0,
      },
      on: {
        init: (e) => {
          e.wrapperEl.style.transitionTimingFunction = 'linear';
        },
      },
      breakpoints: {
        768: {
          spaceBetween: 40
        }
      }
    });


    swiper.init();
  });
};

const paginationSwiper = () => {
  const swiperElements = document.querySelectorAll('.js-pagination-swiper');

  if (swiperElements.length === 0) return;

  swiperElements.forEach(swiperElement => {
    const paginationElement = swiperElement.querySelector('.swiper-pagination');

    let swiper = new Swiper(swiperElement, {
      init: false,
      loop: true,
      speed: 400,
      allowTouchMove: false,
      autoplay: {
        disableOnInteraction: false,
        delay: 5000,
        pauseOnMouseEnter: true
      },
      pagination: {
        el: paginationElement,
        clickable: true
      },
    });


    swiper.init();
  });
};

const thumbnailSwiper = () => {
  const mainSwiperElement = document.querySelector('#js-thumbnail-swiper');
  const triggers = document.querySelectorAll('.js-thumbnail-trigger');

  if (!mainSwiperElement) return;

  const ACTIVE_CLASS = 'is-active';
  const AUTO_PLAY_TIME = 5000;

  triggers[0].classList.add(ACTIVE_CLASS);

  const removeActiveClass = () => {
    triggers.forEach(trigger => {
      if (trigger.classList.contains(ACTIVE_CLASS)) {
        trigger.classList.remove(ACTIVE_CLASS);
      }
    });
  };


  let mainSwiper = new Swiper(mainSwiperElement, {
    init: false,
    effect: 'fade',
    speed: FADE_SPEED,
    allowTouchMove: false,
    loop: true,
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      pauseOnMouseEnter: true,
      disableOnInteraction: false,
      delay: AUTO_PLAY_TIME,
    },
    on: {
      slideChange: () => {
        removeActiveClass();
        triggers[mainSwiper.realIndex].classList.add(ACTIVE_CLASS);
      },
      touchStart: () => {
        mainSwiper.autoplay.pause();
      },
      touchEnd: () => {
        mainSwiper.autoplay.start();
      }
    }
  });

  mainSwiper.init();

  mainSwiperElement.addEventListener('mouseenter', () => {
    mainSwiper.autoplay.pause();
  });


  const triggerClickHandler = (e, index) => {
    mainSwiper.slideToLoop(index);
  };

  triggers.forEach((trigger, index) => {
    trigger.addEventListener('click', (e) => {
      triggerClickHandler(e, index);
    });
  });
};

const relatedSwiper = () => {
  const swiperElement = document.querySelector('.js-related-swiper');

  if (!swiperElement) return;
  const paginationElement = document.querySelector('.js-related-swiper-pagination');
  const prevButton = document.querySelector('.js-swiper-prev-button');
  const nextButton = document.querySelector('.js-swiper-next-button');

  let swiper = new Swiper(swiperElement, {
    init: false,
    slidesPerView: 2,
    spaceBetween: 40,
    speed: 400,
    pagination: {
      el: paginationElement,
      clickable: true
    },
    navigation: {
      nextEl: nextButton,
      prevEl: prevButton,
    },
    breakpoints: {
      768: {
        slidesPerView: 'auto',
        spaceBetween: 80,
      }
    }
  });


  swiper.init();
};

const init = () => {
  carouselSwiper();
  paginationSwiper();
  thumbnailSwiper();
  relatedSwiper();
};

export default init;

export { homeHeroSwiper };